import { AppDispatch, RootState } from '@src/store/store'
import {
  setBackError,
  setCreditLimitDescription,
  setIsLoading,
  setIsLoadingCreditLimit,
  setIsSuccessCreditLimit,
  setPayAndDeb,
  setRecurrentCard,
} from '@src/store/ducks/pay/reducer'
import { selectUserCurrentAddresses } from '@src/store/ducks/user/selectors'
import { payApi } from '@src/api/pay-api'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'

export const payAndDebInfo = (
  type: number, dateStart: string, dateEnd: string,
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoading(true))
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await payApi.getPayAndDebInfo(currentAddresses.accountId, type, dateStart, dateEnd)
      dispatch(setPayAndDeb(result))
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const getPaymentUrl = (sum: number, isReccurent: boolean, payId?: string | null) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await payApi.getPaymentUrl(sum, isReccurent, currentAddresses.accountId, payId)
      window.location.href = result
    }
  } catch (err) {
    console.error(err)
  }
}
export const getRecurrentCard = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      const result = await payApi.getRecurrentCard(currentAddresses.accountId)
      dispatch(setRecurrentCard(result))
    }
  } catch (err) {
    console.error(err)
  }
}
export const setAutoPay = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      await payApi.setAutoPay(currentAddresses.accountId)
    }
  } catch (err) {
    console.error(err)
  }
}

export const addCreditLimit = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingCreditLimit(true))
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      await payApi.addCreditLimit(currentAddresses.accountId, currentAddresses.account)
      dispatch(setIsSuccessCreditLimit(true))
    }
  } catch (err: any) {
    console.error(err)
    dispatch(setBackError(isString(err?.response?.data) ? err.response.data : errors.main))
  } finally {
    dispatch(setIsLoadingCreditLimit(false))
  }
}

export const getCreditLimitDescription = () => async (dispatch: AppDispatch) => {
  try {
    const desc = await payApi.getCreditLimitDescription()

    dispatch(setCreditLimitDescription(desc))
  } catch (err) {
    console.error(err)
  }
}
